import {
  CallOriginModel,
  ICallOriginModel,
} from '@common/models/CallOriginModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class CallOriginService {
  private static baseUrl: string = '/api/callorigin';

  static tags = {
    upsertCallOrigin: 'upsertCallOrigins',
    deleteCallOrigin: 'deleteCallOrigin',
  };

  static upsertCallOrigin = (
    data: ICallOriginModel,
    options?: ServiceMethodOptions,
  ): Promise<CallOriginModel> => {
    return trackPromise(
      new Promise<ICallOriginModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<ICallOriginModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Call Origin updated.', options);
            resolve(new CallOriginModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to update Call Origin.', options);
            reject(err);
          });
      }),
      this.tags.upsertCallOrigin,
    );
  };

  static deleteCallOrigin = (
    callOriginId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${callOriginId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess('Call Origin has been deleted.', options);
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to delete Call Origin.', options);
            reject(err);
          });
      }),
      this.tags.deleteCallOrigin,
    );
  };
}
